import React, { useCallback } from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardHeader from '@/components/material-ui-kit/components/Card/CardHeader';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import CardFooter from '@/components/material-ui-kit/components/Card/CardFooter';
import Muted from '@/components/material-ui-kit/components/Typography/Muted';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@/components/common/ui/Button';
import styles from 'styles/jss/original/components/favorites/favoriteIdeaListItem';
import _ from 'lodash';
import { IIdea } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
  onRequestUpdateFavorite: (id: string) => void;
  invalid: boolean;
};

const FavoriteIdeaListItem: React.FC<ComponentProps> = ({
  idea,
  onRequestUpdateFavorite,
  invalid
}) => {
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );
  const truncate = (str: string, len: number) => {
    if (!_.isEmpty(str)) {
      return str.length <= len ? str : str.substr(0, len) + '...';
    }
  };

  return (
    // @ts-expect-error
    <GridItem xs={6} sm={6} md={6} className={classes.flex}>
      <Card profile plain className={classes.card}>
        <GridContainer>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={5} md={5}>
            <CardHeader image plain>
              <Link href={`/ideas/${idea.fields.slug}`}>
                <a>
                  <picture>
                    <source
                      srcSet={`${idea.fields.thumbnail.fields.file.url}?fm=webp`}
                      media='(min-width: 641px)'
                    />
                    <source
                      srcSet={`${idea.fields.thumbnail.fields.file.url}?fm=webp&fit=pad&w=400`}
                      media='(max-width: 640px)'
                    />
                    <img src={idea.fields.thumbnail.fields.file.url} alt={idea.fields.title} />
                  </picture>
                  <div className={classes.coloredShadow} />
                </a>
              </Link>
            </CardHeader>
          </GridItem>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={7} md={7}>
            <CardBody plain className={classes.cardBody}>
              <Link href={`/ideas/${idea.fields.slug}`}>
                <a>
                  <Muted>
                    <h6 className={classes.cardCategory}>{idea.fields.cat}</h6>
                  </Muted>
                  <h4 className={classes.cardTitle}>{idea.fields.title}</h4>
                  <p className={classes.description}>{truncate(idea.fields.desc, 25)}</p>
                </a>
              </Link>
            </CardBody>
            <CardFooter plain className={classes.cardFooter}>
              <Tooltip
                id='tooltip-top'
                title='削除する'
                placement='top'
                classes={{ tooltip: classes.tooltip }}
              >
                <Button
                  justIcon
                  simple
                  color='gray'
                  disabled={invalid}
                  onClick={() => handleClick(idea.fields.id)}
                >
                  <i className='fas fa-times' />
                </Button>
              </Tooltip>
            </CardFooter>
          </GridItem>
        </GridContainer>
      </Card>
    </GridItem>
  );
};

export default FavoriteIdeaListItem;
